import { render, staticRenderFns } from "./BlockContainer.vue?vue&type=template&id=08330338&scoped=true&"
import script from "./BlockContainer.vue?vue&type=script&lang=js&"
export * from "./BlockContainer.vue?vue&type=script&lang=js&"
import style0 from "./BlockContainer.vue?vue&type=style&index=0&id=08330338&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08330338",
  null
  
)

export default component.exports